import { APP_COLOR, S3_URL } from "../../../const";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { numberFormat } from "../../../helper";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useState } from "react";
import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import AnimationLoading from "../../../components/Animationloading";

function ProductCardList({
  products,
  selectedPrice,
  onSelectProduct,
  checkedProductSelected,
  productDatas,
  productLoading
}) {
  const [loadding, setLoadding] = useState(false);

  useEffect(() => {
    if (products) {
      setLoadding(true);
    } else {
      setLoadding(false);
    }
  }, []);

  return (
    <div className="sale-list-left">
      <div className="sale-product-list">
        <div className="wrapper">
          {(!productDatas?.products && productLoading) ? (
            <AnimationLoading />
          ) : products?.length > 0 ? (
            products?.map((product, index) => (
              <>
                <div
                  key={index}
                  className="sale-product-list-box"
                  onClick={() => onSelectProduct(product)}
                  style={{
                    border:
                      product?.amount <= 0 && product?.hasVariant === false
                        ? "1px solid red"
                        : checkedProductSelected(product)
                          ? "2px solid" + APP_COLOR
                          : "#FFF",
                    borderRadius: 10,
                    // opacity: product?.amount <= 0 ? "70%" : "100%",
                  }}>
                  <div
                    style={{
                      position: "absolute ",
                      width: "auto",
                      height: "23px",
                      display: "flex",
                      justifyContent: "space-between",
                      top: "-5px",
                      fontSize: "14px",
                      marginTop: "5px",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                      color: "#FFFFFF",
                      borderRadius: "8px 0px",
                      background:
                        "rgba(0, 0, 0, 0.5)",
                    }}>
                    <p>
                      {
                        product?.amount ?? 0
                        // + ' / ' + (product?.originAmount ?? product?.amount ?? 0)
                      }
                    </p>
                  </div>
                  <div
                    style={{
                      position: "absolute ",
                      right: "0",
                      width: "auto",
                      height: "23px",
                      display: "flex",
                      justifyContent: "space-between",
                      top: "-5px",
                      fontSize: "14px",
                      marginTop: "5px",
                      color: "#FFFFFF",
                    }}>
                    <p>
                      {checkedProductSelected(product) ? (
                        <CheckCircleIcon sx={{ color: APP_COLOR }} />
                      ) : (
                        ""
                      )}
                    </p>
                  </div>

                  <div style={{ marginTop: "50px" }}>
                    <LazyLoadImage
                      src={
                        product?.hasVariant
                          ? "/assets/image/packxi-tab.png"
                          : Array.isArray(product?.image) && product?.image?.length > 0
                            ? S3_URL + product?.image[0]
                            : typeof product?.image === 'string' && product?.image
                              ? S3_URL + product?.image
                              : "../../../../image/no-img.jpg"
                      }
                      width="100px"
                    />
                    {product?.amount <= 0 && product?.hasVariant === false ? (
                      <div
                        style={{
                          textShadow: "3px 30px 30px #000000",
                          color: "red",
                          fontWeight: "bold",
                          fontSize: 22,
                          position: "absolute",
                          top: 100,
                          left: 20,
                          transform: "rotate(45deg)",
                        }}>
                        ສິນຄ້າໜົດສະຕອັກ
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "0",
                      width: "100%",
                    }}>
                    <div
                      style={{
                        // marginTop: '20px',
                        borderTop: "3px solid #F4F5FA ",
                        position: "relative",
                        marginBottom: "6px",
                        paddingTop: "5px",
                      }}>
                      <div
                        style={{
                          position: "absolute",
                          // width: '100px',
                          height: "30px",
                          top: "-33px",
                          padding: "2px 5px",
                          right: "0",
                          background:
                            "rgba(0, 0, 0, 0.5)",
                          borderRadius: "8px 0px 0px 0px",
                          color: "#FFFFFF",
                          fontstyle: "16px",
                          backdropFilter: "blur(1px)",
                        }}>
                        {product?.isPromo ? (
                          <span style={{ color: "#28a745", fontWeight: "bold" }}>
                            {numberFormat(product?.promoPrice || 0)}
                          </span>
                        ) : (
                          numberFormat(
                            product?.priceOptions[parseInt(selectedPrice)]
                              ?.price ?? product?.price ?? 0
                          )
                        )}
                        {" "}
                        {product?.currency === "BAHT"
                          ? "THB"
                          : product?.currency}
                      </div>
                      <p
                        style={{
                          color: "#092794",
                          fontSize: "1em",
                          overflow: "hidden", paddingLeft: "1em",
                          width: "80%",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}>
                        {product?.name ?? "-"}{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div style={{ height: "250px" }}></div>
              </>
            ))
          ) : (
            <div
              style={{
                fontSize: "24px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "126vh",
                height: "75vh",
                color: "#6B7280",
                fontWeight: "400",
              }}>
              <p>ຍັງບໍ່ມີສິນຄ້າກະລຸນາໄປເພີ່ມສິນຄ້າໃນຄັງກ່ອນ !!!</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default ProductCardList;
